export default {
  header: 'Trebuie să verificăm numărul tău de telefon',
  buttons: {
    confirm: 'Confirmă',
  },
  toasts: {
    invalid_code: 'Cod invalid. Încearcă din nou.',
  },
};
